<template>
  <q-fab
      v-if="$slots.actions"
      v-bind="$attrs"
      vertical-actions-align="right"
      color="accent"
      icon="keyboard_arrow_up"
      direction="up"
      aria-label="Toon acties"
  >
    <slot name="actions" />
  </q-fab>
  <q-btn
      v-else
      v-bind="$attrs"
      fab
      color="accent"
      :icon="icon"
      :aria-label="label"
  >
    <q-tooltip v-if="label"
               class="bg-neutral-80 text-white"
               anchor="center start"
               self="center right">
      {{ label }}
    </q-tooltip>
  </q-btn>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: 'Nieuw',
    },
    icon: {
      type: String,
      default: 'add',
    },
  },
}
</script>
